module.exports = __webpack_public_path__ + "static/img/40005 (3).be41ddb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40005 (3).webp
// module id = F51u
// module chunks = 14